const env = (typeof window !== 'undefined' && window._env_) || {}

const BLUE_API = env.REACT_APP_BLUE_API
const GREEN_API = env.REACT_APP_GREEN_API
const SHARED_API =
  env.REACT_APP_SHARED_API ||
  env.REACT_APP_OOE_SERVICE_URL?.replace(/\/$/, '') ||
  env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') ||
  process.env.REACT_APP_OOE_SERVICE_URL?.replace(/\/$/, '') ||
  process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '')

const parseHosts = csv =>
  (csv || '')
    .split(',')
    .map(h => h.trim())
    .filter(Boolean)

const COLOR_MAP = {
  ...Object.fromEntries(
    parseHosts(env.REACT_APP_BLUE_HOSTS).map(h => [h, BLUE_API]),
  ),
  ...Object.fromEntries(
    parseHosts(env.REACT_APP_GREEN_HOSTS).map(h => [h, GREEN_API]),
  ),
}

export function getApiBase() {
  if (typeof window === 'undefined') return SHARED_API
  const mapped = COLOR_MAP[window.location.hostname]
  return mapped || SHARED_API
}

export const API_URL = `${getApiBase()}/api`
export const OOE_SERVICE_URL = `${getApiBase()}/`
